"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = require("../../base/app");
var is_1 = require("../../base/is");
function callback(app, method, params, fn) {
    return function (_a) {
        var err = _a.err, res = _a.res;
        fn(err, res);
    };
}
var config = {
    getDriverInfo: {},
    getUserInfo: {
        method: function (app) {
            if (app.env === 'daijia') {
                return ['getDriverInfo', 'getToken'];
            }
            return 'getUserInfo';
        },
        param: function (app, method, params) {
            if (app.env === 'didies' || app.env === 'xiaojuchefu') {
                return {};
            }
            return params;
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                switch (app.env) {
                    case 'daijia':
                        res.phone = res.mob;
                        break;
                    case 'kflowerDriver':
                    case 'driver':
                        app.system === 'android' && (res.token = res.ticket);
                        break;
                    case 'finance':
                        res.ticket = res.token;
                        break;
                    case 'xiaojuchefu':
                        res.token = res.ticket;
                        break;
                    case 'driverFreight':
                        res.mob = res.phone;
                        res.token = res.ticket;
                        break;
                }
                return fn(err, res);
            };
        }
    },
    getDeviceMarkInfo: {},
    getSystemInfo: {
        method: function (app) {
            if (app.env === 'xiaojuchefu') {
                return 'getDeviceMarkInfo';
            }
            return 'getSystemInfo';
        },
        param: function (app, method, params) {
            if (app.env === 'xiaojuchefu') {
                return {};
            }
            return params;
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                switch (app.env) {
                    case 'passenger':
                        app.system === 'android' && (res.netstat = res.net_type);
                        break;
                    case 'finance':
                        res.appversion = res.appVersion;
                        break;
                }
                return fn(err, res);
            };
        },
        isSupport: function () {
            return !(is_1.is('daijia') || is_1.is('xiaojuchefu and ios'));
        }
    },
    getPosition: {},
    getHydraData: {},
    getLocationInfo: {
        method: function (app) {
            switch (app.env) {
                case 'daijia':
                    return 'getPosition';
                default:
                    return 'getLocationInfo';
            }
        },
        param: function (app, method, params) {
            if (app.env === 'didies') {
                return null;
            }
            if (app.env === 'xiaojuchefu') {
                return {};
            }
            return params;
        },
        callback: callback,
    },
    resizeImage: {},
    chooseImage: {},
    photograph: {
        method: function (app) {
            switch (app.env) {
                case 'driver':
                case 'xiaojuchefu':
                    return 'chooseImage';
                default:
                    return 'photograph';
            }
        },
        param: function (app, method, params) {
            var source = params.source, type = params.type, quality = params.quality, cut = params.cut, editable = params.editable;
            var tmp = source || type;
            if (app.env === 'driver') {
                var width = params.width, height = params.height, scene = params.scene;
                if (typeof tmp === 'string') {
                    tmp === 'album' && (tmp = 1);
                    tmp === 'photograph' && (tmp = 2);
                    tmp === 'choice' && (tmp = 3);
                }
                return {
                    source: tmp,
                    scene: scene,
                    editable: cut || editable,
                    width: width,
                    height: height,
                    quality: quality
                };
            }
            if (app.env === 'passenger' || app.env === 'finance' || app.env === 'xiaojuchefu') {
                var ext = params.ext;
                if (typeof tmp === 'number') {
                    tmp === 0 && (tmp = 'choice');
                    tmp === 1 && (tmp = 'album');
                    tmp === 2 && (tmp = 'photograph');
                    tmp === 3 && (tmp = 'choice');
                }
                return {
                    type: tmp,
                    quality: quality,
                    cut: cut || editable,
                    ext: ext
                };
            }
            return params;
        },
        callback: callback,
        isSupport: function () {
            return !(is_1.is('daijia') || is_1.is('didies and android') || is_1.is('kflowerDriver and android') || is_1.is('globalDriver and android, globalPassenger and android') || is_1.is('qingjuchelian and android'));
        }
    },
    viewIsBackground: {
        callback: callback,
        shouldCallbackCached: function () {
            return true;
        },
        isSupport: function () {
            return is_1.is('passenger and ios, driver and ios') || is_1.is('kflowerDriver and android, kflowerPassenger') || is_1.is('globalDriver and android, globalPassenger and ios');
        }
    },
    commonAuthorize: {
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                switch (app.env) {
                    case 'passenger':
                        app.system === 'android' && !err && typeof res.auth_back === 'string' &&
                            (res.auth_back = JSON.parse(res.auth_back));
                        return fn(err, res);
                    default:
                        return fn(err, res);
                }
            };
        },
        isSupport: function () {
            return is_1.is('passenger') || is_1.is('kflowerPassenger and ios');
        }
    },
    getToken: {
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia') || is_1.is('driverFreight');
        }
    },
    getDriverState: {
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                switch (app.env) {
                    case 'daijia':
                        return fn(err, { state: res });
                    default:
                        return fn(err, res);
                }
            };
        },
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    isEnabledLocation: {
        callback: callback,
        isSupport: function () {
            return is_1.is('finance and ios');
        }
    },
    getImApolloSwitch: {
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                switch (app.env) {
                    case 'daijia':
                        return fn(err, { res: res });
                    default:
                        return fn(err, res);
                }
            };
        },
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    jumpUrl: {},
    openPage: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'openPage';
                    }
                    else {
                        return 'openNativeWebPage';
                    }
                case 'daijia':
                    return 'jumpUrl';
                case 'driverFreight':
                    if (app_1.compareAppVersion('<', '1.10.60')) {
                        return 'jumpUrl';
                    }
                    return 'openPage';
                default:
                    return 'openPage';
            }
        },
        param: function (app, method, params) {
            var target = params.target, newWindow = params.newWindow, url = params.url, title = params.title, browser = params.browser;
            if (app.env === 'driver' || app.env === 'globalDriver') {
                var newWindowValueMap = {
                    'blank': true,
                    'self': false
                };
                var newWindowTmp = false;
                if (typeof target === 'string' || typeof newWindow === 'string') {
                    newWindowTmp = newWindow ? newWindowValueMap[newWindow] : newWindowValueMap[target];
                }
                else {
                    newWindowTmp = typeof newWindow === 'boolean' ? newWindow : target;
                }
                var browserTmp = target === 'native' ? true : browser;
                return {
                    url: url,
                    newWindow: newWindowTmp,
                    browser: browserTmp
                };
            }
            if (app.env === 'passenger' || app.env === 'globalPassenger' || app.env === 'shunfengche') {
                var targetValueMap = {
                    true: 'blank',
                    false: 'self'
                };
                var tmp = 'blank';
                if (typeof target === 'boolean' || typeof newWindow === 'boolean') {
                    tmp = browser === true ? 'native' : targetValueMap[target] || targetValueMap[newWindow];
                }
                else {
                    tmp = target || newWindow || tmp;
                }
                return {
                    url: url,
                    title: title,
                    target: tmp
                };
            }
            if (app.env === 'daijia' || is_1.is('driverFreight<1.10.60')) {
                return params.url;
            }
            return params;
        },
        callback: callback,
    },
    pageClose: {},
    closePage: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'closePage';
                    }
                    else {
                        return 'page_close';
                    }
                case 'driver':
                    if (app.system === 'ios') {
                        return 'page_close';
                    }
                    else {
                        return 'closePage';
                    }
                default:
                    return 'closePage';
            }
        },
        param: function (app, method, params) {
            if (app.env === 'xiaojuchefu' && app.system === 'android') {
                return {};
            }
            if (app.env === 'qingjuchelian' && app.system === 'android') {
                return {};
            }
            return params;
        },
        callback: callback,
        isSupport: function () {
            return !(is_1.is('daijia') || is_1.is('kflowerDriver and ios'));
        }
    },
    reloadPrePage: {
        isSupport: function () {
            return is_1.is('driverFreight and ios');
        }
    },
    refreshPage: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'refreshPage';
                    }
                    else {
                        return 'page_refresh';
                    }
                default:
                    return 'refreshPage';
            }
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('passenger, finance, kflowerPassenger, globalPassenger') || is_1.is('qingjuchelian and ios');
        }
    },
    setTitle: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'setTitle';
                    }
                    else {
                        return 'updateNaviTitle';
                    }
                case 'kflowerDriver':
                case 'driver':
                    return 'controllerTitle';
                default:
                    return 'setTitle';
            }
        },
        param: function (app, method, params) {
            if (app.env === 'driver' || app.env === 'kflowerDriver') {
                return {
                    vctitle: params.title || params.vctitle || params.navi_title
                };
            }
            if (app.env === 'didies') {
                return {
                    navi_title: params.title || params.vctitle || params.navi_title
                };
            }
            if (app.env === 'qingjuchelian' && app.system === 'android') {
                return {
                    navi_title: params.title || params.vctitle || params.navi_title
                };
            }
            if (app.env === 'driverFreight' || app.env === 'daijia') {
                return params.title;
            }
            return {
                title: params.title || params.vctitle
            };
        },
        callback: callback,
        isSupport: function () {
            return !(is_1.is('daijia and ios') || is_1.is('globalDriver and android, qingjuchelian and android'));
        }
    },
    initEntrance: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'initEntrance';
                    }
                    else {
                        return 'init_entrance';
                    }
                case 'driver':
                    return 'init_entrance';
                default:
                    return 'initEntrance';
            }
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('passenger, driver, finance, kflowerPassenger') || is_1.is('globalPassenger, globalDriver and ios');
        }
    },
    invokeEntrance: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'invokeEntrance';
                    }
                    else {
                        return 'invoke_entrance';
                    }
                case 'driver':
                    return 'share_slide_up';
                default:
                    return 'invokeEntrance';
            }
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('passenger, driver, finance and ios, xiaojuchefu and android') || is_1.is('kflowerPassenger') || is_1.is('globalPassenger, globalDriver and ios');
        }
    },
    showEntrance: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'showEntrance';
                    }
                    else {
                        return 'show_entrance';
                    }
                case 'driver':
                    return 'show_entrance';
                case 'daijia':
                    return 'showButton';
                default:
                    return 'showEntrance';
            }
        },
        callback: callback,
        shouldCallbackCached: function () {
            return true;
        },
        isSupport: function () {
            return is_1.is('passenger, driver, finance, kflowerPassenger, globalPassenger') || is_1.is('didies and android, qingjuchelian and ios');
        }
    },
    hideButton: {},
    hideEntrance: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'hideEntrance';
                    }
                    else {
                        return 'hide_entrance';
                    }
                case 'driver':
                    return 'hide_entrance';
                case 'daijia':
                    return 'hideButton';
                default:
                    return 'hideEntrance';
            }
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('passenger, finance, kflowerPassenger and ios, qingjuchelian and ios') || is_1.is('globalPassenger');
        }
    },
    requestPermissions: {
        callback: callback,
        isSupport: function () {
            return is_1.is('finance and ios');
        }
    },
    shareWeixinAppmsg: {},
    weixinAppmsg: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'shareWeixinAppmsg';
                    }
                    else {
                        return 'share_weixin_appmsg';
                    }
                case 'driver':
                    if (app.system === 'ios') {
                        return 'share_weixin_appmsg';
                    }
                    else if (app.system === 'android') {
                        return 'callWXShare';
                    }
                    return 'callWXShare';
                default:
                    return 'shareWeixinAppmsg';
            }
        },
        param: function (app, method, params) {
            if (app.env === 'driver') {
                var conf = {
                    url: params.url || params.share_url,
                    icon: params.icon || params.icon_url || params.share_icon_url || params.imageUrl,
                    title: params.title || params.share_title,
                    desc: params.desc || params.content || params.share_content || params.descript
                };
                var cfg = void 0;
                if (app.system === 'ios') {
                    cfg = {
                        share_url: conf.url,
                        share_icon_url: conf.icon,
                        share_title: conf.title,
                        share_content: conf.desc
                    };
                    return JSON.stringify(cfg);
                }
                else if (app.system === 'android') {
                    cfg = {
                        url: conf.url,
                        imageUrl: conf.icon,
                        title: conf.title,
                        descript: conf.desc,
                        isFriendCircle: false
                    };
                    return cfg;
                }
            }
            return params;
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                res && res.share_result && (res.shareResult = res.share_result);
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('passenger, driver, finance and ios, didies, xiaojuchefu and android') || is_1.is('kflowerPassenger, kflowerDriver and ios') || is_1.is('globalPassenger and android');
        }
    },
    showToast: {
        param: function (app, method, params) {
            if (app.env === 'daijia') {
                return params.msg;
            }
            return params;
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia and android');
        }
    },
    shareSms: {
        method: function (app) {
            switch (app.env) {
                case 'driver':
                    return 'share_sms';
                default:
                    return 'shareSms';
            }
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('driver');
        }
    },
    shareWeixinTimeline: {},
    weixinTimeline: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'shareWeixinTimeline';
                    }
                    else {
                        return 'share_weixin_timeline';
                    }
                case 'driver':
                    if (app.system === 'ios') {
                        return 'share_weixin_timeline';
                    }
                    else if (app.system === 'android') {
                        return 'callWXShare';
                    }
                    return 'callWXShare';
                default:
                    return 'shareWeixinTimeline';
            }
        },
        param: function (app, method, params) {
            var conf = {
                url: params.url || params.share_url,
                icon: params.icon || params.icon_url || params.share_icon_url || params.imageUrl,
                title: params.title || params.share_title,
                content: params.desc || params.content || params.share_content || params.descript
            };
            if (app.env === 'driver') {
                var cfg = void 0;
                if (app.system === 'ios') {
                    cfg = {
                        share_url: conf.url,
                        share_icon_url: conf.icon,
                        share_title: conf.title,
                        share_content: conf.content
                    };
                    return JSON.stringify(cfg);
                }
                else if (app.system === 'android') {
                    cfg = {
                        url: conf.url,
                        imageUrl: conf.icon,
                        title: conf.title,
                        descript: conf.content,
                        isFriendCircle: true
                    };
                    return cfg;
                }
            }
            return conf;
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                res && res.share_result && (res.shareResult = res.share_result);
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('passenger, driver, finance and ios, didies, kflowerPassenger') || is_1.is('globalPassenger and android, qingjuchelian and ios');
        }
    },
    shareQqAppmsg: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'shareQqAppmsg';
                    }
                    else {
                        return 'share_qq_appmsg';
                    }
                default:
                    return 'shareQqAppmsg';
            }
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                res && res.share_result && (res.shareResult = res.share_result);
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('passenger, finance and ios') || is_1.is('globalPassenger and android, kflowerPassenger and android');
        }
    },
    shareQzone: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'shareQzone';
                    }
                    else {
                        return 'share_qzone';
                    }
                default:
                    return 'shareQzone';
            }
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                res && res.share_result && (res.shareResult = res.share_result);
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('passenger, finance and ios, kflowerPassenger and android') || is_1.is('globalPassenger and android');
        }
    },
    shareAlipayFriend: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'shareAlipayFriend';
                    }
                    else {
                        return 'share_alipay_friend';
                    }
                default:
                    return 'shareAlipayFriend';
            }
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                res && res.share_result && (res.shareResult = res.share_result);
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('passenger, kflowerPassenger and android') || is_1.is('globalPassenger and android');
        }
    },
    shareAlipayLife: {
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'shareAlipayLife';
                    }
                    else {
                        return 'share_alipay_life';
                    }
                default:
                    return 'shareAlipayLife';
            }
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                res && res.share_result && (res.shareResult = res.share_result);
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('passenger, kflowerPassenger and android') || is_1.is('globalPassenger and android');
        }
    },
    commonPay: {
        method: function (app, method, params) {
            if (params === void 0) { params = {}; }
            if (app.env === 'driver') {
                switch (params.type) {
                    case 'weixin':
                        return 'wxPayRequest';
                    case 'ali':
                        return 'aliPayRequest';
                }
            }
            return 'commonPay';
        },
        param: function (app, method, params) {
            if (params === void 0) { params = {}; }
            var payParams = params.pay_params;
            switch (app.env) {
                case 'driver':
                    if (params.type === 'weixin') {
                        return payParams;
                    }
                    else if (params.type === 'ali') {
                        return {
                            pay_string: typeof payParams === 'string'
                                ? payParams
                                : payParams.orderStr
                        };
                    }
                    break;
                case 'passenger':
                    if (params.type === 'ali') {
                        return {
                            type: 'ali',
                            pay_params: typeof payParams === 'object'
                                ? payParams : {
                                orderStr: payParams,
                                alipaySchema: 'diditaxi'
                            }
                        };
                    }
                    break;
                default:
                    return params;
            }
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                switch (app.env) {
                    case 'driver':
                        res.statCode === -2 && (res.payResult = 2);
                        res.payResult === -3 && (res.payResult = 1);
                        break;
                    case 'passenger':
                        res.payResult = res.pay_result;
                        break;
                }
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('passenger, driver, finance and ios, didies') || is_1.is('qingjuchelian and android');
        }
    },
    orderDetailInfo: {
        callback: callback,
        isSupport: function () {
            return is_1.is('driver, kflowerDriver and android');
        }
    },
    checkOrderDetail: {
        callback: callback,
        isSupport: function () {
            return is_1.is('driver, kflowerDriver and android');
        }
    },
    driverOut: {},
    startCarRequest: {
        method: function (app) {
            switch (app.env) {
                case 'globalDriver':
                case 'globalPassenger':
                    return 'driverOut';
                default:
                    return 'driver_out';
            }
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('driver, kflowerDriver, globalDriver');
        }
    },
    closeCarRequest: {
        callback: callback,
        isSupport: function () {
            return is_1.is('driver, kflowerDriver, globalDriver and android');
        }
    },
    faceRecognize: {
        method: function (app) {
            switch (app.env) {
                case 'globalDriver':
                case 'globalPassenger':
                    return 'faceRecognition';
                default:
                    return 'faceRecognize';
            }
        },
        param: function (app, method, params) {
            if (app.env === 'globalDriver' || app.env === 'globalPassenger') {
                var sessionId = params.sessionId, bizCode = params.bizCode, other = __rest(params, ["sessionId", "bizCode"]);
                return __assign({ session_id: sessionId, bizcode: bizCode }, other);
            }
            return params;
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res, rawData = _a.rawData;
                switch (app.env) {
                    case 'globalDriver':
                    case 'globalPassenger':
                        res = {
                            resultCode: rawData.result,
                            faceResultCode: rawData.result,
                            sessionId: rawData.session_id,
                            resultMessage: rawData.msg
                        };
                        break;
                }
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('driver, finance, passenger, didies, kflowerDriver, kflowerPassenger, globalPassenger, globalDriver') || is_1.is('qingjuchelian and android');
        }
    },
    toMainPage: {},
    goToIndexPage: {},
    returnHomePage: {},
    toHomePage: {
        method: function (app) {
            switch (app.env) {
                case 'daijia':
                    if (app.system === 'android') {
                        return 'returnHomePage';
                    }
                    else if (app.system === 'ios') {
                        return 'goToIndexPage';
                    }
                case 'driver':
                    return 'toMainPage';
                default:
                    return 'toHomePage';
            }
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('driver, daijia, driverFreight');
        }
    },
    goToSysSettings: {
        param: function (app, method, params) {
            if (app.env === 'daijia') {
                return params.pageIndex;
            }
            return params;
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    showValidatedPhoto: {
        param: function (app, method, params) {
            if (app.env === 'daijia') {
                return params.oid;
            }
            return params;
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    showEvaluation: {
        param: function (app, method, params) {
            if (app.env === 'daijia') {
                return params.oid;
            }
            return params;
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    goToSettings: {
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    addCornerButton: {
        param: function (app, method, params, fn) {
            if (app.env === 'driver') {
                var jsCall = '' + params.jsCallback + new Date().getTime();
                params.jsCallback = jsCall;
                if (app.system === 'ios') {
                    window.DidiJSBridge && window.DidiJSBridge.registerHandler(jsCall, fn);
                }
                else if (app.system === 'android') {
                    window[jsCall] = fn;
                }
                return params;
            }
            return params;
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('driver');
        }
    },
    launchNav: {
        callback: callback,
        isSupport: function () {
            return is_1.is('driver, xiaojuchefu') || is_1.is('kflowerPassenger and android, kflowerDriver and android');
        }
    },
    resetBack: {
        callback: callback,
        isSupport: function () {
            return is_1.is('driver');
        }
    },
    requestLogout: {
        param: function (app, method, params) {
            if (app.env === 'xiaojuchefu') {
                return {};
            }
            return params;
        },
        method: function (app) {
            switch (app.env) {
                case 'driver':
                    return 'exitLogin';
                default:
                    return 'requestLogout';
            }
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('driver, xiaojuchefu');
        }
    },
    launchScan: {
        param: function (app, method, params) {
            if (app.env === 'xiaojuchefu') {
                return {};
            }
            return params;
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                switch (app.env) {
                    case 'driver':
                        err = res.err || null;
                        delete res.err;
                        return fn(err, res);
                    default:
                        res.ret = res.ret || res.message;
                        return fn(err, res);
                }
            };
        },
        isSupport: function () {
            return is_1.is('driver, passenger, finance, xiaojuchefu') || is_1.is('kflowerPassenger and ios') || is_1.is('globalDriver, kflowerDriver and ios');
        }
    },
    apolloGetToggle: {
        method: function (app) {
            return 'apolloGetToggle';
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('globalPassenger and ios');
        }
    },
    requestLogin: {
        param: function (app, method, params) {
            if (app.env === 'xiaojuchefu' && app.system === 'android') {
                return {};
            }
            return params;
        },
        method: function (app) {
            switch (app.env) {
                case 'passenger':
                    if (app_1.compareAppVersion('>', '5.0.0')) {
                        return 'requestLogin';
                    }
                    else {
                        return 'callNativeLoginWithCallback';
                    }
                default:
                    return 'requestLogin';
            }
        },
        callback: callback,
        isSupport: function () {
            return !is_1.is('driver, daijia, kflowerDriver, globalPassenger');
        }
    },
    showCancelReason: {
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    showInvoicePhoto: {
        param: function (app, method, params) {
            if (app.env === 'daijia') {
                return params.oid;
            }
            return params;
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    goToSurveyPage: {
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    goToAlipay: {
        callback: callback,
        isSupport: function () {
            return is_1.is('daijia');
        }
    },
    clearCache: {
        method: function (app) {
            return 'clearCache';
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('passenger and android, kflowerPassenger and android');
        }
    },
    controlBackPress: {
        method: function (app) {
            return 'controlBackPress';
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('driver');
        }
    },
    orderReassignState: {
        method: function (app) {
            return 'orderReassignState';
        },
        isSupport: function () {
            return is_1.is('driver and ios');
        },
        callback: callback
    },
    openUniPay: {
        method: function (app) {
            return 'openUniPay';
        },
        callback: callback,
        isSupport: function () {
            return is_1.is('driver and android') || is_1.is('finance and ios') || is_1.is('globalPassenger and ios') || is_1.is('kflowerPassenger and android') || is_1.is('kflowerDriver');
        }
    },
    wechatCardAuthAction: {
        callback: callback,
        isSupport: function () {
            return is_1.is('passenger, finance, didies, qingjuchelian and ios, kflowerPassenger and ios');
        }
    },
    getAppInfo: {
        callback: callback,
        isSupport: function () {
            return is_1.is('driver') || is_1.is('xiaojuchefu and android') || is_1.is('kflowerDriver and android');
        }
    },
    launchWeChatMiniApp: {
        isSupport: function () {
            return (is_1.is('ios') && is_1.is('driver>=5.1.52')) || (is_1.is('android') && is_1.is('driver>=5.1.54')) || is_1.is('kflowerDriver, kflowerPassenger');
        }
    },
    collect: {
        isSupport: function (app) {
            return app.communication === 'fusion';
        }
    },
    getContact: {
        method: function (app) {
            if (app.env === 'globalPassenger') {
                return 'openAddressBook';
            }
            return 'getContact';
        },
        callback: function (app, method, params, fn) {
            return function (_a) {
                var err = _a.err, res = _a.res;
                if (app.env === 'globalPassenger' || app.env === 'globalDriver') {
                    res.phone = typeof res.phone === 'string' ? [res.phone] : res.phone;
                }
                return fn(err, res);
            };
        },
        isSupport: function () {
            return is_1.is('globalPassenger, globalDriver');
        }
    },
    updateNaviView: {
        isSupport: function () {
            return is_1.is('passenger');
        }
    }
};
exports.config = config;
config.shareWeixinAppmsg = config.weixinAppmsg;
config.shareWeixinTimeline = config.weixinTimeline;
config.chooseImage = config.photograph;
config.resizeImage = config.photograph;
config.getHydraData = config.getLocationInfo;
config.getDeviceMarkInfo = config.getSystemInfo;
config.hideButton = config.hideEntrance;
config.getDriverInfo = config.getUserInfo;
config.jumpUrl = config.openPage;
config.goToIndexPage = config.toHomePage;
config.returnHomePage = config.toHomePage;
config.toMainPage = config.toHomePage;
config.getPosition = config.getLocationInfo;
config.pageClose = config.closePage;
config.driverOut = config.startCarRequest;
